<template>
  <div class="game">
    <div>
      <div>#################################################</div>
      <div style="text-align: center">{{title}}</div>
      <div>#################################################</div>
    </div>
    <br />
    <div>{{description}}</div>
    <br />
    <div v-if="showFooter">
      <label v-if="!gameOver">What would you like to do?</label>
      <div class="cursor">
        <input
            type="text"
            class="command"
            v-if="!gameOver"
            v-on:keyup.enter="parseCommand"
            v-on:blur="parseCommand"
            v-model="command"
        />
        <i></i>
      </div>
      <div v-if="gameOver" style="text-align: center">
        <div>#################################################</div>
        <div style="text-align: center">{{ending}}</div>
        <div>#################################################</div>
        <br />
        <button v-on:click="areaId=null">PLAY AGAIN</button>
      </div>
    </div>

  </div>

</template>

<script>
import gameData from "../assets/sidwell-birthday.json";

export default {
  name: "AdventureLand",
  props: {
    msg: String
  },
  data: function() {
    return {
      areaId: null,
      command: "",
      description: "",
      showFooter: false
    }
  },
  computed: {
    title: function() {
      return gameData["title"].join("\n");
    },
    intro: function() {
      return gameData["introduction"];
    },
    area: function() {
      if (this.areaId === null) {
        return gameData["areas"][gameData["starting_area"]];
      }
      return gameData["areas"][this.areaId]
    },
    gameOver: function() {
      if ("game_over" in this.area) {
        return this.area["game_over"];
      }
      return false;
    },
    ending: function() {
      return gameData["ending"].join("\n");
    }
  },
  methods: {
    parseCommand: function() {
      if (this.command === "") {
        return
      }
      let cmd_split = this.command.toLowerCase().split(" ")
      let cmd = cmd_split.shift();
      let target = cmd_split.join(" ")
      switch(true) {
        case /help/.test(cmd):
          this.print_lines([
            "The voice of Abraham Lincoln resonates all around you...",
            "'Try some of the following:",
            "  - help: displays this message.",
            "  - go: to move yourself to a new location.",
            "  - look: to get more information about something in your area.'"
          ]);
          break;
        case /look|inspect|play|eat/.test(cmd):
          this.inspect(target);
          break;
        case /go|travel|walk|run|continue/.test(cmd):
          this.navigate(target)
          break;
        default:
          this.print_lines(["I don't understand the command: " + cmd])
      }
      this.command = "";
    },
    navigate: function(target) {
      let area_found = false;
      for (const [key, value] of Object.entries(this.area["routes"])) {
        if (new RegExp(key).test(target)) {
          area_found = true;
          this.areaId = value;
          break;
        }
      }
      if (!area_found) {
        this.print_lines(["You can't go there from your current location."])
      }
    },
    inspect: function(target) {
      if (!target) {
        this.print_lines(this.area["description"]);
      }
      else {
        let item_found = false;
        for (const [key, value] of Object.entries(this.area["details"])) {
          if (new RegExp(key).test(target)) {
            item_found = true;
            this.print_lines(value);
            break;
          }
        }
        if (!item_found) {
          this.print_lines(["You don't see anything special about that."]);
        }
      }
    },
    print_lines: async function(lines) {
      this.showFooter = false;
      this.description = "";
      window.scrollTo(0,0);
      const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
      }

      let text = lines.join("\n")
      for (let i = 0; i < text.length; i++) {
        this.description += text[i];
        await sleep(10);
      }
      this.showFooter = true;
    }
  },
  mounted() {
    this.print_lines([].concat(this.intro, [""], this.area["description"]));
  },
  watch: {
    area: function (area) {
      let lines = []
      if (this.areaId === null) {
        lines = lines.concat(this.intro);
      }
      lines = lines.concat(area["description"]);
      this.print_lines(lines);
    }
  }
}
</script>

<style scoped>
.game {
  font-size: small;
  width: 380px;
}

div {
  white-space: pre-line;
}

input {
  border:0;
  outline:0;
  width: 300px;
}

input:focus {
  outline:none!important;
}

input[type="text"], textarea {
  background-color: black;
  color: #20e020;
}

button {
  box-shadow: none;
  background-color: black;
  border-color: #20e020;
  color: #20e020;
  padding: 2px;
}

.cursor {
  position: relative;
}
.cursor	i {
  position: absolute;
  width: 2px;
  height: 90%;
  background-color: #20e020;
  left: 0px;
  top: 5%;
  animation: 800ms blink infinite;
  opacity: 1;
}

.cursor input:focus + i {
  display: none;
}

@keyframes blink {
  from { opacity: 1; }
  to { opacity: 0; }
}

</style>